<div class="modal-groups-users">
  <div class="modal-groups-users__header">
    <div class="modal-groups-users__header__title">
      {{ dataTranslateModalUserGroups?.title }}
    </div>
    <mat-icon class="modal-groups-users__header__close" (click)="close(false)"
      >close</mat-icon
    >
  </div>
  <div class="modal-groups-users__content">
    <div
      class="load-image"
      (dragover)="onDragOver()"
      (dragleave)="onDragLeave($event)"
    >
      <label for=""> {{ dataTranslateModalUserGroups?.titleIcon }} </label>
      <div class="inputDrag" [ngClass]="{ 'active-drag': isDragActive }">
        <mat-icon *ngIf="fileUrl === ''" class="mr-2">backup</mat-icon>
        <span *ngIf="fileUrl === ''" style="text-align: center">
          {{ dataTranslateModalUserGroups?.textDrag }}
        </span>
        <img *ngIf="fileUrl !== ''" [src]="fileUrl" class="max-h-48" alt="" />
        <zf-s3-upload-image
          [version]="'1'"
          [url]="
            'https://res.cloudinary.com/du4jrqkyo/image/upload/v1549938954/picture.jpg'
          "
          [urlPresigned]="
            'https://api-services.mango-soft.com/stage/get-presigned-url'
          "
          [bucket]="'cdn.mango-soft.com'"
          [folder]="'access-control/files'"
          [client]="'zerofractal'"
          [imageZoom]="false"
          (urlUploaded)="urlUploadedHandle($event)"
          (urlUploadedError)="urlUploadedErrorHandle($event)"
        ></zf-s3-upload-image>
      </div>
    </div>
    <div class="form">
      <div class="form-group">
        <label for="">
          {{ dataTranslateModalUserGroups?.nameClient }}
          <span style="color: red">*</span>
        </label>
        <input
          type="text"
          [placeholder]="dataTranslateModalUserGroups?.nameClient"
          [(ngModel)]="nameClient"
        />
      </div>
    </div>
  </div>
  <div class="modal-groups-users__footer">
    <button class="modal-groups-users__footer__close" (click)="close(false)">
      {{ dataTranslateModalUserGroups?.buttonCancel }}
    </button>
    <button
      class="modal-groups-users__footer__save"
      (click)="save()"
      [disabled]="nameClient === ''"
    >
    {{ dataTranslateModalUserGroups?.buttonSave }}
  </button>
  </div>
</div>
